import * as Ariakit from '@ariakit/react'
import { PropsWithChildren } from 'react'

export interface TabsProps extends Ariakit.TabProviderProps {
  className?: string
}

export function Tabs({ className, children }: PropsWithChildren<TabsProps>) {
  return (
    <Ariakit.TabProvider>
      <div className={className}>{children}</div>
    </Ariakit.TabProvider>
  )
}
